
<template>
    <div class="prompt-modal-wrap">
      <transition name="popup">
        <div class="modal" v-show="show">
          <div class="modal-banner">
            <Icon :img="require('../../assets/kubaolottery-header-modal.png')" class="banner"/>
          </div>
          <div class="modal-body">
            <span>是否跳转至“酷宝大转盘”游戏</span>
          </div>
          <div class="modal-actions">
            <Icon :img="require('../../assets/icon-cancel-modal.png')" class="action" @click.native="handleCancel"/>
            <Icon :img="require('../../assets/icon-kubaolottery-btn-modal.png')" class="action" @click.native="go"/>
          </div>
        </div>
      </transition>
      <div class="mask" v-if="show"></div>
    </div>
</template>

<script>
export default {
  props: ["url"],
  data(){
    return {
      show: false,
    }
  },
  methods: {
    go() {
      window.location.href=this.url
    },
    handleCancel(){
      this.show = false;
    },
    display(){
      this.show = true;
    }
  }
};
</script>

<style lang="less" scoped>

.modal{
  width: 80vw;
  border-radius: 2.13vw;
  background: white;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  z-index: 12;

  .modal-banner{
    .banner{
      width: 100%;
      height: 24vw;
    }
  }

  .modal-body{
    text-align: center;
    span{
      font-size: 4.8vw;
      line-height: 5em;
      color: #333;
    }
  }

  .modal-actions{
    text-align: center;
    padding-bottom: 5.33vw;

    .action{
      width: 34.67vw;
      height: 12vw;
      display: inline-block;
      margin: 1.33vw;

    }
  }
}

.mask{
  position: fixed;
  z-index: 11;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background: black;
  opacity: .6;
}
</style>





// WEBPACK FOOTER //
// src/components/kubaolottery/PromptModal.vue